import axios from 'axios';

export const searchDrugs = async (charactersToSearch) => {
  const url = `${process.env.REACT_APP_API_URL}/drugs?search=${charactersToSearch.toUpperCase()}`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  try {
    const {data} = await axios.get(url,{headers: headers});
    return data;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


